export class deliveredUrls {
    ARCHIVE_GTR_URL = "gtr/v1/delivered-gather/archive";
    DELETE_DELIVERED_GTR_URL = "gtr/v1/delivered-gather";
}
